export const ADMIN_ROLES = ["ADMIN", "SYSTEM_ADMIN"];
export const GROUP_LEADER_ROLE = ["GROUP_LAEDER"];
export const FAMILY_LEADER_ROLE = ["FAMILY_LEADER"];
export const MEMBER_ROLE = ["MEMBER"];
